goog.provide("shadow.js.shim.module$date_fns$toDate$default");
shadow.js.shim.module$date_fns$toDate$default = shadow.js.require(119, {})["default"];
